import { useNavigate } from "react-router-dom";
import { ErrorText, Panel, Spinner } from "../../components/ui";
import { fmtDate } from "../../lib/format";
import { useMarkRead, useNotifications } from "./hooks";
import type { AppNotification } from "./api";

export function NotificationsPage() {
  const { data, isLoading, error } = useNotifications();
  const markRead = useMarkRead();
  const navigate = useNavigate();

  function open(n: AppNotification) {
    if (!n.read) markRead.mutate(n.id);
    const opportunityId = n.data?.opportunityId;
    if (typeof opportunityId === "string") navigate(`/opportunities/${opportunityId}`);
  }

  return (
    <Panel title="Notifications">
      <ErrorText error={error} />
      {isLoading ? (
        <Spinner />
      ) : (
        data?.data.map((n) => (
          <div
            key={n.id}
            className={`notification-row ${n.read ? "" : "unread"}`}
            onClick={() => open(n)}
          >
            <div>
              <div>{n.title}</div>
              {n.body && <div className="body">{n.body}</div>}
            </div>
            <span className="muted">{fmtDate(n.createdAt)}</span>
          </div>
        ))
      )}
      {data?.data.length === 0 && <p className="muted">Aucune notification.</p>}
    </Panel>
  );
}
